import RightPanel from './RightPanel';

export { COLLAPSED_BAR_WIDTH } from './styles';
export default RightPanel;
